import React, { Component } from 'react';
import { Message, Icon, Button } from 'semantic-ui-react';
import { performVersionCheck } from '../../utils/versionUtils';
import { FRONTEND_VERSION } from '../../constants';
import './VersionNotification.css';

class VersionNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      needsUpdate: false,
      message: '',
      currentVersion: null,
      dismissed: false,
      checking: true
    };
    this.checkInterval = null;
  }

  componentDidMount() {
    this.checkVersion();
    // Check version every 5 minutes
    this.checkInterval = setInterval(() => {
      this.checkVersion();
    }, 5 * 60 * 1000);
  }

  componentWillUnmount() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }

  checkVersion = async () => {
    try {
      const result = await performVersionCheck();
      if (result.needsUpdate) {
        this.setState({
          needsUpdate: true,
          message: result.message,
          currentVersion: result.currentVersion,
          checking: false,
          dismissed: false
        });
      } else {
        this.setState({ checking: false });
      }
    } catch (error) {
      console.error('Version check failed:', error);
      this.setState({ checking: false });
    }
  };

  handleDismiss = () => {
    this.setState({ dismissed: true });
  };

  handleRefresh = () => {
    // Force reload without cache
    window.location.reload(true);
  };

  render() {
    const { needsUpdate, message, currentVersion, dismissed, checking } = this.state;

    if (checking || !needsUpdate || dismissed) {
      return null;
    }

    return (
      <div className="version-notification-container">
        <Message warning className="version-notification">
          <Message.Header>
            <Icon name="sync alternate" />
            New Version Available
          </Message.Header>
          <Message.Content>
            <p>{message}</p>
            {currentVersion && (
              <p className="version-details">
                <strong>Your version:</strong> {FRONTEND_VERSION} 
                <span className="version-separator">→</span>
                <strong>Latest version:</strong> {currentVersion.frontend}
              </p>
            )}
            <div className="version-actions">
              <Button 
                primary 
                size="small" 
                onClick={this.handleRefresh}
              >
                <Icon name="refresh" />
                Refresh Now (Ctrl+Shift+R)
              </Button>
              <Button 
                basic 
                size="small" 
                onClick={this.handleDismiss}
              >
                Remind Me Later
              </Button>
            </div>
          </Message.Content>
        </Message>
      </div>
    );
  }
}

export default VersionNotification;
